export var Icons;
(function (Icons) {
    Icons["SSOFACEBOOK16"] = "ssofacebook16";
    Icons["SSOFACEBOOK24"] = "ssofacebook24";
    Icons["ACCESSIBILITY16"] = "accessibility16";
    Icons["ACCESSIBILITY24"] = "accessibility24";
    Icons["ACTIVATE16"] = "activate16";
    Icons["ACTIVATE24"] = "activate24";
    Icons["ACTIVITY16"] = "activity16";
    Icons["ACTIVITY24"] = "activity24";
    Icons["ADD_COMMENT16"] = "addComment16";
    Icons["ADD_COMMENT24"] = "addComment24";
    Icons["AIRPLANE16"] = "airplane16";
    Icons["AIRPLANE24"] = "airplane24";
    Icons["ALERT16"] = "alert16";
    Icons["ALERT24"] = "alert24";
    Icons["ALERT_OUTLINE16"] = "alertOutline16";
    Icons["ALERT_OUTLINE24"] = "alertOutline24";
    Icons["ANDROID16"] = "android16";
    Icons["ANDROID24"] = "android24";
    Icons["APPLAUSE16"] = "applause16";
    Icons["APPLAUSE24"] = "applause24";
    Icons["APPLE16"] = "apple16";
    Icons["APPLE24"] = "apple24";
    Icons["ARROW_CURVED16"] = "arrowCurved16";
    Icons["ARROW_CURVED24"] = "arrowCurved24";
    Icons["ARROW_DOWN16"] = "arrowDown16";
    Icons["ARROW_DOWN24"] = "arrowDown24";
    Icons["ARROW_DOWN_LEFT16"] = "arrowDownLeft16";
    Icons["ARROW_DOWN_LEFT24"] = "arrowDownLeft24";
    Icons["ARROW_DOWN_RIGHT16"] = "arrowDownRight16";
    Icons["ARROW_DOWN_RIGHT24"] = "arrowDownRight24";
    Icons["ARROW_LEFT16"] = "arrowLeft16";
    Icons["ARROW_LEFT24"] = "arrowLeft24";
    Icons["ARROW_RIGHT16"] = "arrowRight16";
    Icons["ARROW_RIGHT24"] = "arrowRight24";
    Icons["ARROW_UP16"] = "arrowUp16";
    Icons["ARROW_UP24"] = "arrowUp24";
    Icons["ARROW_UP_LEFT16"] = "arrowUpLeft16";
    Icons["ARROW_UP_LEFT24"] = "arrowUpLeft24";
    Icons["ARROW_UP_RIGHT16"] = "arrowUpRight16";
    Icons["ARROW_UP_RIGHT24"] = "arrowUpRight24";
    Icons["ASSOCIATE16"] = "associate16";
    Icons["ASSOCIATE24"] = "associate24";
    Icons["AVATAR16"] = "avatar16";
    Icons["AVATAR24"] = "avatar24";
    Icons["BAR_CODE16"] = "barCode16";
    Icons["BAR_CODE24"] = "barCode24";
    Icons["BIKE16"] = "bike16";
    Icons["BIKE24"] = "bike24";
    Icons["BOLD16"] = "bold16";
    Icons["BOLD24"] = "bold24";
    Icons["BOLT16"] = "bolt16";
    Icons["BOLT24"] = "bolt24";
    Icons["BOLT_OFF16"] = "boltOff16";
    Icons["BOLT_OFF24"] = "boltOff24";
    Icons["BOOK16"] = "book16";
    Icons["BOOK24"] = "book24";
    Icons["BULK16"] = "bulk16";
    Icons["BULK24"] = "bulk24";
    Icons["BULLETLIST16"] = "bulletlist16";
    Icons["BULLETLIST24"] = "bulletlist24";
    Icons["BUS_MOYEN"] = "busMoyen";
    Icons["BUS16"] = "bus16";
    Icons["BUS24"] = "bus24";
    Icons["CALENDAR16"] = "calendar16";
    Icons["CALENDAR24"] = "calendar24";
    Icons["CAMERA16"] = "camera16";
    Icons["CAMERA24"] = "camera24";
    Icons["CAR16"] = "car16";
    Icons["CAR24"] = "car24";
    Icons["CARD_CREDIT_ACTIVATED16"] = "cardCreditActivated16";
    Icons["CARD_CREDIT_ACTIVATED24"] = "cardCreditActivated24";
    Icons["CARD_PIN16"] = "cardPin16";
    Icons["CARD_PIN24"] = "cardPin24";
    Icons["CARE_SOLIDARITY16"] = "careSolidarity16";
    Icons["CARE_SOLIDARITY24"] = "careSolidarity24";
    Icons["CASH16"] = "cash16";
    Icons["CASH24"] = "cash24";
    Icons["CASHBACK16"] = "cashback16";
    Icons["CASHBACK24"] = "cashback24";
    Icons["CASHBACK_BIS16"] = "cashbackBis16";
    Icons["CASHBACK_BIS24"] = "cashbackBis24";
    Icons["CC_SCAN16"] = "ccScan16";
    Icons["CC_SCAN24"] = "ccScan24";
    Icons["CELERY16"] = "celery16";
    Icons["CELERY24"] = "celery24";
    Icons["CERTIFICATE16"] = "certificate16";
    Icons["CERTIFICATE24"] = "certificate24";
    Icons["CHAT16"] = "chat16";
    Icons["CHAT24"] = "chat24";
    Icons["CHECK16"] = "check16";
    Icons["CHECK24"] = "check24";
    Icons["CHECK_CIRCLE16"] = "checkCircle16";
    Icons["CHECK_CIRCLE24"] = "checkCircle24";
    Icons["CHECK_OUTLINE16"] = "checkOutline16";
    Icons["CHECK_OUTLINE24"] = "checkOutline24";
    Icons["CHECKLIST16"] = "checklist16";
    Icons["CHECKLIST24"] = "checklist24";
    Icons["CHECKMARK16"] = "checkmark16";
    Icons["CHECKMARK24"] = "checkmark24";
    Icons["CHEF16"] = "chef16";
    Icons["CHEF24"] = "chef24";
    Icons["CHEVRON_DOUBLE_DOWN_CIRCLE_OUTLINE16"] = "chevronDoubleDownCircleOutline16";
    Icons["CHEVRON_DOUBLE_DOWN_CIRCLE_OUTLINE24"] = "chevronDoubleDownCircleOutline24";
    Icons["CHEVRON_DOUBLE_LEFT_CIRCLE_OUTLINE16"] = "chevronDoubleLeftCircleOutline16";
    Icons["CHEVRON_DOUBLE_LEFT_CIRCLE_OUTLINE24"] = "chevronDoubleLeftCircleOutline24";
    Icons["CHEVRON_DOUBLE_RIGHT_CIRCLE_OUTLINE16"] = "chevronDoubleRightCircleOutline16";
    Icons["CHEVRON_DOUBLE_RIGHT_CIRCLE_OUTLINE24"] = "chevronDoubleRightCircleOutline24";
    Icons["CHEVRON_DOUBLE_UP_CIRCLE_OUTLINE16"] = "chevronDoubleUpCircleOutline16";
    Icons["CHEVRON_DOUBLE_UP_CIRCLE_OUTLINE24"] = "chevronDoubleUpCircleOutline24";
    Icons["CHEVRON_DOWN16"] = "chevronDown16";
    Icons["CHEVRON_DOWN24"] = "chevronDown24";
    Icons["CHEVRON_DOWN_CIRCLE16"] = "chevronDownCircle16";
    Icons["CHEVRON_DOWN_CIRCLE24"] = "chevronDownCircle24";
    Icons["CHEVRON_DOWN_FILLED16"] = "chevronDownFilled16";
    Icons["CHEVRON_DOWN_FILLED24"] = "chevronDownFilled24";
    Icons["CHEVRON_LEFT16"] = "chevronLeft16";
    Icons["CHEVRON_LEFT24"] = "chevronLeft24";
    Icons["CHEVRON_LEFT_CIRCLE16"] = "chevronLeftCircle16";
    Icons["CHEVRON_LEFT_CIRCLE24"] = "chevronLeftCircle24";
    Icons["CHEVRON_LEFT_FILLED16"] = "chevronLeftFilled16";
    Icons["CHEVRON_LEFT_FILLED24"] = "chevronLeftFilled24";
    Icons["CHEVRON_RIGHT16"] = "chevronRight16";
    Icons["CHEVRON_RIGHT24"] = "chevronRight24";
    Icons["CHEVRON_RIGHT_CIRCLE16"] = "chevronRightCircle16";
    Icons["CHEVRON_RIGHT_CIRCLE24"] = "chevronRightCircle24";
    Icons["CHEVRON_RIGHT_FILLED16"] = "chevronRightFilled16";
    Icons["CHEVRON_RIGHT_FILLED24"] = "chevronRightFilled24";
    Icons["CHEVRON_UP16"] = "chevronUp16";
    Icons["CHEVRON_UP24"] = "chevronUp24";
    Icons["CHEVRON_UP_CIRCLE16"] = "chevronUpCircle16";
    Icons["CHEVRON_UP_CIRCLE24"] = "chevronUpCircle24";
    Icons["CHEVRON_UP_FILLED16"] = "chevronUpFilled16";
    Icons["CHEVRON_UP_FILLED24"] = "chevronUpFilled24";
    Icons["CHICKEN16"] = "chicken16";
    Icons["CHICKEN24"] = "chicken24";
    Icons["CHILD_CARE16"] = "childCare16";
    Icons["CHILD_CARE24"] = "childCare24";
    Icons["CITY16"] = "city16";
    Icons["CITY24"] = "city24";
    Icons["CLICK_COLLECT16"] = "clickCollect16";
    Icons["CLICK_COLLECT24"] = "clickCollect24";
    Icons["CLICK_DELIVERY16"] = "clickDelivery16";
    Icons["CLICK_DELIVERY24"] = "clickDelivery24";
    Icons["CLICKABLE_SORTING_DOWN16"] = "clickableSortingDown16";
    Icons["CLICKABLE_SORTING_DOWN24"] = "clickableSortingDown24";
    Icons["CLICKABLE_SORTING_NEUTRAL16"] = "clickableSortingNeutral16";
    Icons["CLICKABLE_SORTING_NEUTRAL24"] = "clickableSortingNeutral24";
    Icons["CLICKABLE_SORTING_UP16"] = "clickableSortingUp16";
    Icons["CLICKABLE_SORTING_UP24"] = "clickableSortingUp24";
    Icons["CLOCK16"] = "clock16";
    Icons["CLOCK24"] = "clock24";
    Icons["CLOCK_ALTERNATIVE16"] = "clockAlternative16";
    Icons["CLOCK_ALTERNATIVE24"] = "clockAlternative24";
    Icons["CLOTHING16"] = "clothing16";
    Icons["CLOTHING24"] = "clothing24";
    Icons["COMMENT16"] = "comment16";
    Icons["COMMENT24"] = "comment24";
    Icons["CONCIERGERIE16"] = "conciergerie16";
    Icons["CONCIERGERIE24"] = "conciergerie24";
    Icons["CONNECT16"] = "connect16";
    Icons["CONNECT24"] = "connect24";
    Icons["CONSUMPTION16"] = "consumption16";
    Icons["CONSUMPTION24"] = "consumption24";
    Icons["COPY16"] = "copy16";
    Icons["COPY24"] = "copy24";
    Icons["CROWN16"] = "crown16";
    Icons["CROWN24"] = "crown24";
    Icons["CULTURE16"] = "culture16";
    Icons["CULTURE24"] = "culture24";
    Icons["CURVE_CHART16"] = "curveChart16";
    Icons["CURVE_CHART24"] = "curveChart24";
    Icons["CUTLERY16"] = "cutlery16";
    Icons["CUTLERY24"] = "cutlery24";
    Icons["DASHBOARD16"] = "dashboard16";
    Icons["DASHBOARD24"] = "dashboard24";
    Icons["DEACTIVATE16"] = "deactivate16";
    Icons["DEACTIVATE24"] = "deactivate24";
    Icons["DELETE16"] = "delete16";
    Icons["DELETE24"] = "delete24";
    Icons["DELETE_CIRCLE_FILLED16"] = "deleteCircleFilled16";
    Icons["DELETE_CIRCLE_FILLED24"] = "deleteCircleFilled24";
    Icons["DELETE_CIRCLE_OUTLINE16"] = "deleteCircleOutline16";
    Icons["DELETE_CIRCLE_OUTLINE24"] = "deleteCircleOutline24";
    Icons["DELIVERY16"] = "delivery16";
    Icons["DELIVERY24"] = "delivery24";
    Icons["DIAMOND16"] = "diamond16";
    Icons["DIAMOND24"] = "diamond24";
    Icons["DIRECTION16"] = "direction16";
    Icons["DIRECTION24"] = "direction24";
    Icons["DISPLAY16"] = "display16";
    Icons["DISPLAY24"] = "display24";
    Icons["DOWNLOAD16"] = "download16";
    Icons["DOWNLOAD24"] = "download24";
    Icons["DRAGGABLE16"] = "draggable16";
    Icons["DRAGGABLE24"] = "draggable24";
    Icons["E_CHECK16"] = "eCheck16";
    Icons["E_CHECK24"] = "eCheck24";
    Icons["ECHEQUE16"] = "echeque16";
    Icons["ECHEQUE24"] = "echeque24";
    Icons["ECO16"] = "eco16";
    Icons["ECO24"] = "eco24";
    Icons["EDIT_OFF16"] = "editOff16";
    Icons["EDIT_OFF24"] = "editOff24";
    Icons["EGG16"] = "egg16";
    Icons["EGG24"] = "egg24";
    Icons["EMOJI_SAD16"] = "emojiSad16";
    Icons["EMOJI_SAD24"] = "emojiSad24";
    Icons["EMOJI_SMILE16"] = "emojiSmile16";
    Icons["EMOJI_SMILE24"] = "emojiSmile24";
    Icons["EMPLOYEE16"] = "employee16";
    Icons["EMPLOYEE24"] = "employee24";
    Icons["EMPLOYEE_GROUP16"] = "employeeGroup16";
    Icons["EMPLOYEE_GROUP24"] = "employeeGroup24";
    Icons["ENGAGEMENT16"] = "engagement16";
    Icons["ENGAGEMENT24"] = "engagement24";
    Icons["ERASE16"] = "erase16";
    Icons["ERASE24"] = "erase24";
    Icons["EXCEL16"] = "excel16";
    Icons["EXCEL24"] = "excel24";
    Icons["EXCHANGE16"] = "exchange16";
    Icons["EXCHANGE24"] = "exchange24";
    Icons["EXPENSES_MANAGEMENT16"] = "expensesManagement16";
    Icons["EXPENSES_MANAGEMENT24"] = "expensesManagement24";
    Icons["EYE_CLOSE_FILLED16"] = "eyeCloseFilled16";
    Icons["EYE_CLOSE_FILLED24"] = "eyeCloseFilled24";
    Icons["EYE_CLOSE_OUTLINE16"] = "eyeCloseOutline16";
    Icons["EYE_CLOSE_OUTLINE24"] = "eyeCloseOutline24";
    Icons["EYE_OPEN_FILLED16"] = "eyeOpenFilled16";
    Icons["EYE_OPEN_FILLED24"] = "eyeOpenFilled24";
    Icons["EYE_OPEN_OUTLINE16"] = "eyeOpenOutline16";
    Icons["EYE_OPEN_OUTLINE24"] = "eyeOpenOutline24";
    Icons["FACE_ID16"] = "faceId16";
    Icons["FACE_ID24"] = "faceId24";
    Icons["FACEBOOK16"] = "facebook16";
    Icons["FACEBOOK24"] = "facebook24";
    Icons["FAVICON_DEFAULT_BOLDY_BLUE16"] = "faviconDefaultBoldyBlue16";
    Icons["FAVICON_DEFAULT_DEEPBLUE16"] = "faviconDefaultDeepblue16";
    Icons["FAVICON_DEFAULT_ULTRA_GREEN16"] = "faviconDefaultUltraGreen16";
    Icons["FAVICON_INVERSE_BOLDY_BLUE16"] = "faviconInverseBoldyBlue16";
    Icons["FAVICON_INVERSE_DEEPBLUE16"] = "faviconInverseDeepblue16";
    Icons["FILE_DELETE16"] = "fileDelete16";
    Icons["FILE_DELETE24"] = "fileDelete24";
    Icons["FILE16"] = "file16";
    Icons["FILE24"] = "file24";
    Icons["FILE_EDIT16"] = "fileEdit16";
    Icons["FILE_EDIT24"] = "fileEdit24";
    Icons["FILTER16"] = "filter16";
    Icons["FILTER24"] = "filter24";
    Icons["FILTER_APPLIED16"] = "filterApplied16";
    Icons["FILTER_APPLIED24"] = "filterApplied24";
    Icons["FINGERPRINT16"] = "fingerprint16";
    Icons["FINGERPRINT24"] = "fingerprint24";
    Icons["FISH16"] = "fish16";
    Icons["FISH24"] = "fish24";
    Icons["FLAKE16"] = "flake16";
    Icons["FLAKE24"] = "flake24";
    Icons["FLAME16"] = "flame16";
    Icons["FLAME24"] = "flame24";
    Icons["FLEET16"] = "fleet16";
    Icons["FLEET24"] = "fleet24";
    Icons["FLEXIBLE_BENEFIT16"] = "flexibleBenefit16";
    Icons["FLEXIBLE_BENEFIT24"] = "flexibleBenefit24";
    Icons["FOOD16"] = "food16";
    Icons["FOOD24"] = "food24";
    Icons["FUEL16"] = "fuel16";
    Icons["FUEL24"] = "fuel24";
    Icons["GIFT16"] = "gift16";
    Icons["GIFT24"] = "gift24";
    Icons["GLOBE16"] = "globe16";
    Icons["GLOBE24"] = "globe24";
    Icons["GOOGLE16"] = "google16";
    Icons["GOOGLE24"] = "google24";
    Icons["GROSSERY_SHOPPING16"] = "grosseryShopping16";
    Icons["GROSSERY_SHOPPING24"] = "grosseryShopping24";
    Icons["HEALTH16"] = "health16";
    Icons["HEALTH24"] = "health24";
    Icons["HEART_FILLED16"] = "heartFilled16";
    Icons["HEART_FILLED24"] = "heartFilled24";
    Icons["HEART_OUTLINE16"] = "heartOutline16";
    Icons["HEART_OUTLINE24"] = "heartOutline24";
    Icons["HELP16"] = "help16";
    Icons["HELP24"] = "help24";
    Icons["HISTORY16"] = "history16";
    Icons["HISTORY24"] = "history24";
    Icons["HOURGLASS16"] = "hourglass16";
    Icons["HOURGLASS24"] = "hourglass24";
    Icons["HOUSE16"] = "house16";
    Icons["HOUSE24"] = "house24";
    Icons["IDENTIFICATION16"] = "identification16";
    Icons["IDENTIFICATION24"] = "identification24";
    Icons["INCENTIVE16"] = "incentive16";
    Icons["INCENTIVE24"] = "incentive24";
    Icons["INFO16"] = "info16";
    Icons["INFO24"] = "info24";
    Icons["INFO_OUTLINE16"] = "infoOutline16";
    Icons["INFO_OUTLINE24"] = "infoOutline24";
    Icons["INSTAGRAM16"] = "instagram16";
    Icons["INSTAGRAM24"] = "instagram24";
    Icons["LAPTOP16"] = "laptop16";
    Icons["LAPTOP24"] = "laptop24";
    Icons["LEISURE16"] = "leisure16";
    Icons["LEISURE24"] = "leisure24";
    Icons["LINE_BREAK16"] = "lineBreak16";
    Icons["LINE_BREAK24"] = "lineBreak24";
    Icons["LINKEDIN16"] = "linkedin16";
    Icons["LINKEDIN24"] = "linkedin24";
    Icons["LISTVIEW16"] = "listview16";
    Icons["LISTVIEW24"] = "listview24";
    Icons["LOCK16"] = "lock16";
    Icons["LOCK24"] = "lock24";
    Icons["LOGIN16"] = "login16";
    Icons["LOGIN24"] = "login24";
    Icons["LOGOUT16"] = "logout16";
    Icons["LOGOUT24"] = "logout24";
    Icons["LOYALTY_PROGRAM16"] = "loyaltyProgram16";
    Icons["LOYALTY_PROGRAM24"] = "loyaltyProgram24";
    Icons["LUPINES16"] = "lupines16";
    Icons["LUPINES24"] = "lupines24";
    Icons["MAIL16"] = "mail16";
    Icons["MAIL24"] = "mail24";
    Icons["MAIZE16"] = "maize16";
    Icons["MAIZE24"] = "maize24";
    Icons["MASTERCARD16"] = "mastercard16";
    Icons["MASTERCARD24"] = "mastercard24";
    Icons["MEAL16"] = "meal16";
    Icons["MEAL24"] = "meal24";
    Icons["MEAL_FOOD16"] = "mealFood16";
    Icons["MEAL_FOOD24"] = "mealFood24";
    Icons["MEDAL16"] = "medal16";
    Icons["MEDAL24"] = "medal24";
    Icons["MEETING16"] = "meeting16";
    Icons["MEETING24"] = "meeting24";
    Icons["MENU16"] = "menu16";
    Icons["MENU24"] = "menu24";
    Icons["MERCHANT16"] = "merchant16";
    Icons["MERCHANT24"] = "merchant24";
    Icons["MICROSOFT16"] = "microsoft16";
    Icons["MICROSOFT24"] = "microsoft24";
    Icons["MINUS16"] = "minus16";
    Icons["MINUS24"] = "minus24";
    Icons["MINUS_CIRCLE_FILLED16"] = "minusCircleFilled16";
    Icons["MINUS_CIRCLE_FILLED24"] = "minusCircleFilled24";
    Icons["MINUS_CIRCLE_OUTLINE16"] = "minusCircleOutline16";
    Icons["MINUS_CIRCLE_OUTLINE24"] = "minusCircleOutline24";
    Icons["MOBILE16"] = "mobile16";
    Icons["MOBILE24"] = "mobile24";
    Icons["MOBILITY16"] = "mobility16";
    Icons["MOBILITY24"] = "mobility24";
    Icons["MOLLUSC16"] = "mollusc16";
    Icons["MOLLUSC24"] = "mollusc24";
    Icons["MONET_REFRESH16"] = "monetRefresh16";
    Icons["MONET_REFRESH24"] = "monetRefresh24";
    Icons["MONEY16"] = "money16";
    Icons["MONEY24"] = "money24";
    Icons["MULTI_BENEFITS16"] = "multiBenefits16";
    Icons["MULTI_BENEFITS24"] = "multiBenefits24";
    Icons["MUSTARD16"] = "mustard16";
    Icons["MUSTARD24"] = "mustard24";
    Icons["NOTIFICATIONS16"] = "notifications16";
    Icons["NOTIFICATIONS24"] = "notifications24";
    Icons["NUT16"] = "nut16";
    Icons["NUT24"] = "nut24";
    Icons["OFFICE16"] = "office16";
    Icons["OFFICE24"] = "office24";
    Icons["ON_OFF16"] = "onOff16";
    Icons["ON_OFF24"] = "onOff24";
    Icons["ONLINE_PAYMENT16"] = "onlinePayment16";
    Icons["ONLINE_PAYMENT24"] = "onlinePayment24";
    Icons["OPTIMIZE16"] = "optimize16";
    Icons["OPTIMIZE24"] = "optimize24";
    Icons["PAPERCLIP16"] = "paperclip16";
    Icons["PAPERCLIP24"] = "paperclip24";
    Icons["PARCEL_DELIVERY16"] = "parcelDelivery16";
    Icons["PARCEL_DELIVERY24"] = "parcelDelivery24";
    Icons["PARCEL_DELIVERY_BIS16"] = "parcelDeliveryBis16";
    Icons["PARCEL_DELIVERY_BIS24"] = "parcelDeliveryBis24";
    Icons["PASSWORD16"] = "password16";
    Icons["PASSWORD24"] = "password24";
    Icons["PASTE16"] = "paste16";
    Icons["PASTE24"] = "paste24";
    Icons["PATH16"] = "path16";
    Icons["PATH24"] = "path24";
    Icons["PAYPAL16"] = "paypal16";
    Icons["PAYPAL24"] = "paypal24";
    Icons["PDF16"] = "pdf16";
    Icons["PDF24"] = "pdf24";
    Icons["PEANUT16"] = "peanut16";
    Icons["PEANUT24"] = "peanut24";
    Icons["PEN16"] = "pen16";
    Icons["PEN24"] = "pen24";
    Icons["PERSON16"] = "person16";
    Icons["PERSON24"] = "person24";
    Icons["PHONE16"] = "phone16";
    Icons["PHONE24"] = "phone24";
    Icons["PICTURE16"] = "picture16";
    Icons["PICTURE24"] = "picture24";
    Icons["PIE_CHART16"] = "pieChart16";
    Icons["PIE_CHART24"] = "pieChart24";
    Icons["PIN16"] = "pin16";
    Icons["PIN24"] = "pin24";
    Icons["PIN_FILLED16"] = "pinFilled16";
    Icons["PIN_FILLED24"] = "pinFilled24";
    Icons["PIN_OUTLINE16"] = "pinOutline16";
    Icons["PIN_OUTLINE24"] = "pinOutline24";
    Icons["PLAY16"] = "play16";
    Icons["PLAY24"] = "play24";
    Icons["PLUS16"] = "plus16";
    Icons["PLUS24"] = "plus24";
    Icons["PLUS_CIRCLE_FILLED16"] = "plusCircleFilled16";
    Icons["PLUS_CIRCLE_FILLED24"] = "plusCircleFilled24";
    Icons["PLUS_CIRCLE_OUTLINE16"] = "plusCircleOutline16";
    Icons["PLUS_CIRCLE_OUTLINE24"] = "plusCircleOutline24";
    Icons["PO_S16"] = "poS16";
    Icons["PO_S24"] = "poS24";
    Icons["POSITION16"] = "position16";
    Icons["POSITION24"] = "position24";
    Icons["PRICE_TAG16"] = "priceTag16";
    Icons["PRICE_TAG24"] = "priceTag24";
    Icons["PRINT16"] = "print16";
    Icons["PRINT24"] = "print24";
    Icons["PRIVACY16"] = "privacy16";
    Icons["PRIVACY24"] = "privacy24";
    Icons["PROMOTIONS16"] = "promotions16";
    Icons["PROMOTIONS24"] = "promotions24";
    Icons["Q_A16"] = "qA16";
    Icons["Q_A24"] = "qA24";
    Icons["QR_CARD16"] = "qrCard16";
    Icons["QR_CARD24"] = "qrCard24";
    Icons["QR_CODE16"] = "qrCode16";
    Icons["QR_CODE24"] = "qrCode24";
    Icons["QR_PHONE16"] = "qrPhone16";
    Icons["QR_PHONE24"] = "qrPhone24";
    Icons["QUESTION16"] = "question16";
    Icons["QUESTION24"] = "question24";
    Icons["QUESTION_FILLED16"] = "questionFilled16";
    Icons["QUESTION_FILLED24"] = "questionFilled24";
    Icons["RECEIPT16"] = "receipt16";
    Icons["RECEIPT24"] = "receipt24";
    Icons["REFRESH16"] = "refresh16";
    Icons["REFRESH24"] = "refresh24";
    Icons["REIMBURSEMENT16"] = "reimbursement16";
    Icons["REIMBURSEMENT24"] = "reimbursement24";
    Icons["REORDER16"] = "reorder16";
    Icons["REORDER24"] = "reorder24";
    Icons["RESIZING16"] = "resizing16";
    Icons["RESIZING24"] = "resizing24";
    Icons["ROCKET16"] = "rocket16";
    Icons["ROCKET24"] = "rocket24";
    Icons["RSS16"] = "rss16";
    Icons["RSS24"] = "rss24";
    Icons["SCHRIMP16"] = "schrimp16";
    Icons["SCHRIMP24"] = "schrimp24";
    Icons["SCOOTER16"] = "scooter16";
    Icons["SCOOTER24"] = "scooter24";
    Icons["SCREEN16"] = "screen16";
    Icons["SCREEN24"] = "screen24";
    Icons["SDX_CARD16"] = "sdxCard16";
    Icons["SDX_CARD24"] = "sdxCard24";
    Icons["SDX_CARD_PLUS16"] = "sdxCardPlus16";
    Icons["SDX_CARD_PLUS24"] = "sdxCardPlus24";
    Icons["SDX_CARD_SLASHED16"] = "sdxCardSlashed16";
    Icons["SDX_CARD_SLASHED24"] = "sdxCardSlashed24";
    Icons["SEARCH16"] = "search16";
    Icons["SEARCH24"] = "search24";
    Icons["SECURITY16"] = "security16";
    Icons["SECURITY24"] = "security24";
    Icons["SERACH_FILTER16"] = "serachFilter16";
    Icons["SERACH_FILTER24"] = "serachFilter24";
    Icons["SESAME16"] = "sesame16";
    Icons["SESAME24"] = "sesame24";
    Icons["SETTINGS16"] = "settings16";
    Icons["SETTINGS24"] = "settings24";
    Icons["SETTINGS_BIS16"] = "settingsBis16";
    Icons["SETTINGS_BIS24"] = "settingsBis24";
    Icons["SHARE16"] = "share16";
    Icons["SHARE24"] = "share24";
    Icons["SHOPPING_BAG16"] = "shoppingBag16";
    Icons["SHOPPING_BAG24"] = "shoppingBag24";
    Icons["SHOPPING_CART16"] = "shoppingCart16";
    Icons["SHOPPING_CART24"] = "shoppingCart24";
    Icons["SHOPPING_CART_ADD16"] = "shoppingCartAdd16";
    Icons["SHOPPING_CART_ADD24"] = "shoppingCartAdd24";
    Icons["SORTING_DOWN16"] = "sortingDown16";
    Icons["SORTING_DOWN24"] = "sortingDown24";
    Icons["SORTING_NEUTRAL16"] = "sortingNeutral16";
    Icons["SORTING_NEUTRAL24"] = "sortingNeutral24";
    Icons["SORTING_UP16"] = "sortingUp16";
    Icons["SORTING_UP24"] = "sortingUp24";
    Icons["SOYBEAN16"] = "soybean16";
    Icons["SOYBEAN24"] = "soybean24";
    Icons["SPICY16"] = "spicy16";
    Icons["SPICY24"] = "spicy24";
    Icons["SPLIT_PAYMENT16"] = "splitPayment16";
    Icons["SPLIT_PAYMENT24"] = "splitPayment24";
    Icons["SPLIT_PAYMENT_ACTIVE16"] = "splitPaymentActive16";
    Icons["SPLIT_PAYMENT_ACTIVE24"] = "splitPaymentActive24";
    Icons["SPLIT_PAYMENT_DELETE16"] = "splitPaymentDelete16";
    Icons["SPLIT_PAYMENT_DELETE24"] = "splitPaymentDelete24";
    Icons["SPLIT_PAYMENT_ENROLL16"] = "splitPaymentEnroll16";
    Icons["SPLIT_PAYMENT_ENROLL24"] = "splitPaymentEnroll24";
    Icons["SPORT_CULTURE16"] = "sportCulture16";
    Icons["SPORT_CULTURE24"] = "sportCulture24";
    Icons["STAR_FILLED16"] = "starFilled16";
    Icons["STAR_FILLED24"] = "starFilled24";
    Icons["STAR_FILLED_CIRCLE16"] = "starFilledCircle16";
    Icons["STAR_FILLED_CIRCLE24"] = "starFilledCircle24";
    Icons["STAR_OUTLINE16"] = "starOutline16";
    Icons["STAR_OUTLINE24"] = "starOutline24";
    Icons["STAR_OUTLINE_CIRCLE16"] = "starOutlineCircle16";
    Icons["STAR_OUTLINE_CIRCLE24"] = "starOutlineCircle24";
    Icons["STATS16"] = "stats16";
    Icons["STATS24"] = "stats24";
    Icons["STORE16"] = "store16";
    Icons["STORE24"] = "store24";
    Icons["SULFITES16"] = "sulfites16";
    Icons["SULFITES24"] = "sulfites24";
    Icons["SWITCH_OFF16"] = "switchOff16";
    Icons["SWITCH_OFF24"] = "switchOff24";
    Icons["SWITCH_ON16"] = "switchOn16";
    Icons["SWITCH_ON24"] = "switchOn24";
    Icons["TABLET16"] = "tablet16";
    Icons["TABLET24"] = "tablet24";
    Icons["TALK16"] = "talk16";
    Icons["TALK24"] = "talk24";
    Icons["TELECOMMUNICATION16"] = "telecommunication16";
    Icons["TELECOMMUNICATION24"] = "telecommunication24";
    Icons["TETRAPACK16"] = "tetrapack16";
    Icons["TETRAPACK24"] = "tetrapack24";
    Icons["THREE_DOTS_HORIZONTAL16"] = "threeDotsHorizontal16";
    Icons["THREE_DOTS_HORIZONTAL24"] = "threeDotsHorizontal24";
    Icons["THREE_DOTS_VERTICAL16"] = "threeDotsVertical16";
    Icons["THREE_DOTS_VERTICAL24"] = "threeDotsVertical24";
    Icons["THUMB_DOWN16"] = "thumbDown16";
    Icons["THUMB_DOWN24"] = "thumbDown24";
    Icons["THUMB_UP16"] = "thumbUp16";
    Icons["THUMB_UP24"] = "thumbUp24";
    Icons["TICKET16"] = "ticket16";
    Icons["TICKET24"] = "ticket24";
    Icons["TICKET_VARIANT16"] = "ticketVariant16";
    Icons["TICKET_VARIANT24"] = "ticketVariant24";
    Icons["TOP_UP16"] = "topUp16";
    Icons["TOP_UP24"] = "topUp24";
    Icons["TRAINING16"] = "training16";
    Icons["TRAINING24"] = "training24";
    Icons["TRAMWAY16"] = "tramway16";
    Icons["TRAMWAY24"] = "tramway24";
    Icons["TRANSLATE16"] = "translate16";
    Icons["TRANSLATE24"] = "translate24";
    Icons["TRASH16"] = "trash16";
    Icons["TRASH24"] = "trash24";
    Icons["TRAVEL16"] = "travel16";
    Icons["TRAVEL24"] = "travel24";
    Icons["TWITTER16"] = "twitter16";
    Icons["TWITTER24"] = "twitter24";
    Icons["UNIFORM16"] = "uniform16";
    Icons["UNIFORM24"] = "uniform24";
    Icons["UNLOCK16"] = "unlock16";
    Icons["UNLOCK24"] = "unlock24";
    Icons["UPLOAD16"] = "upload16";
    Icons["UPLOAD24"] = "upload24";
    Icons["USER_GROUP16"] = "userGroup16";
    Icons["USER_GROUP24"] = "userGroup24";
    Icons["VISA16"] = "visa16";
    Icons["VISA24"] = "visa24";
    Icons["VOUCHER16"] = "voucher16";
    Icons["VOUCHER24"] = "voucher24";
    Icons["WAITER16"] = "waiter16";
    Icons["WAITER24"] = "waiter24";
    Icons["WALK16"] = "walk16";
    Icons["WALK24"] = "walk24";
    Icons["WALLET16"] = "wallet16";
    Icons["WALLET24"] = "wallet24";
    Icons["WALLET_LOADING16"] = "walletLoading16";
    Icons["WALLET_LOADING24"] = "walletLoading24";
    Icons["WALLET_PLUS16"] = "walletPlus16";
    Icons["WALLET_PLUS24"] = "walletPlus24";
    Icons["WALLET_REFRESH16"] = "walletRefresh16";
    Icons["WALLET_REFRESH24"] = "walletRefresh24";
    Icons["WALLET_SYNC16"] = "walletSync16";
    Icons["WALLET_SYNC24"] = "walletSync24";
    Icons["WARNING16"] = "warning16";
    Icons["WARNING24"] = "warning24";
    Icons["WARNING_OUTLINE16"] = "warningOutline16";
    Icons["WARNING_OUTLINE24"] = "warningOutline24";
    Icons["WELLBEING16"] = "wellbeing16";
    Icons["WELLBEING24"] = "wellbeing24";
    Icons["WELLNESS16"] = "wellness16";
    Icons["WELLNESS24"] = "wellness24";
    Icons["WHATSAPP16"] = "whatsapp16";
    Icons["WHATSAPP24"] = "whatsapp24";
    Icons["WHEEL16"] = "wheel16";
    Icons["WHEEL24"] = "wheel24";
    Icons["WIFI16"] = "wifi16";
    Icons["WIFI24"] = "wifi24";
    Icons["WIFI_OFF16"] = "wifiOff16";
    Icons["WIFI_OFF24"] = "wifiOff24";
    Icons["XMARK16"] = "xmark16";
    Icons["XMARK24"] = "xmark24";
    Icons["YOUTUBE16"] = "youtube16";
    Icons["YOUTUBE24"] = "youtube24";
})(Icons || (Icons = {}));
export var FlagIcons;
(function (FlagIcons) {
    FlagIcons["FLAG_AD"] = "flagAD";
    FlagIcons["FLAG_AE"] = "flagAE";
    FlagIcons["FLAG_AF"] = "flagAF";
    FlagIcons["FLAG_AG"] = "flagAG";
    FlagIcons["FLAG_AI"] = "flagAI";
    FlagIcons["FLAG_AL"] = "flagAL";
    FlagIcons["FLAG_AM"] = "flagAM";
    FlagIcons["FLAG_AN"] = "flagAN";
    FlagIcons["FLAG_AO"] = "flagAO";
    FlagIcons["FLAG_AR"] = "flagAR";
    FlagIcons["FLAG_AT"] = "flagAT";
    FlagIcons["FLAG_AU"] = "flagAU";
    FlagIcons["FLAG_AW"] = "flagAW";
    FlagIcons["FLAG_AX"] = "flagAX";
    FlagIcons["FLAG_AZ"] = "flagAZ";
    FlagIcons["FLAG_BA"] = "flagBA";
    FlagIcons["FLAG_BB"] = "flagBB";
    FlagIcons["FLAG_BD"] = "flagBD";
    FlagIcons["FLAG_BE"] = "flagBE";
    FlagIcons["FLAG_BF"] = "flagBF";
    FlagIcons["FLAG_BG"] = "flagBG";
    FlagIcons["FLAG_BH"] = "flagBH";
    FlagIcons["FLAG_BI"] = "flagBI";
    FlagIcons["FLAG_BJ"] = "flagBJ";
    FlagIcons["FLAG_BM"] = "flagBM";
    FlagIcons["FLAG_BN"] = "flagBN";
    FlagIcons["FLAG_BO"] = "flagBO";
    FlagIcons["FLAG_BR"] = "flagBR";
    FlagIcons["FLAG_BS"] = "flagBS";
    FlagIcons["FLAG_BT"] = "flagBT";
    FlagIcons["FLAG_BW"] = "flagBW";
    FlagIcons["FLAG_BY"] = "flagBY";
    FlagIcons["FLAG_BZ"] = "flagBZ";
    FlagIcons["FLAG_CA"] = "flagCA";
    FlagIcons["FLAG_CAF"] = "flagCAF";
    FlagIcons["FLAG_CAS"] = "flagCAS";
    FlagIcons["FLAG_CD"] = "flagCD";
    FlagIcons["FLAG_CEU"] = "flagCEU";
    FlagIcons["FLAG_CF"] = "flagCF";
    FlagIcons["FLAG_CG"] = "flagCG";
    FlagIcons["FLAG_CH"] = "flagCH";
    FlagIcons["FLAG_CI"] = "flagCI";
    FlagIcons["FLAG_CL"] = "flagCL";
    FlagIcons["FLAG_CM"] = "flagCM";
    FlagIcons["FLAG_CN"] = "flagCN";
    FlagIcons["FLAG_CNA"] = "flagCNA";
    FlagIcons["FLAG_CO"] = "flagCO";
    FlagIcons["FLAG_COC"] = "flagCOC";
    FlagIcons["FLAG_CR"] = "flagCR";
    FlagIcons["FLAG_CSA"] = "flagCSA";
    FlagIcons["FLAG_CU"] = "flagCU";
    FlagIcons["FLAG_CV"] = "flagCV";
    FlagIcons["FLAG_CY"] = "flagCY";
    FlagIcons["FLAG_CZ"] = "flagCZ";
    FlagIcons["FLAG_DE"] = "flagDE";
    FlagIcons["FLAG_DJ"] = "flagDJ";
    FlagIcons["FLAG_DK"] = "flagDK";
    FlagIcons["FLAG_DM"] = "flagDM";
    FlagIcons["FLAG_DO"] = "flagDO";
    FlagIcons["FLAG_DZ"] = "flagDZ";
    FlagIcons["FLAG_EC"] = "flagEC";
    FlagIcons["FLAG_EE"] = "flagEE";
    FlagIcons["FLAG_EG"] = "flagEG";
    FlagIcons["FLAG_ER"] = "flagER";
    FlagIcons["FLAG_ES"] = "flagES";
    FlagIcons["FLAG_ET"] = "flagET";
    FlagIcons["FLAG_EU"] = "flagEU";
    FlagIcons["FLAG_FI"] = "flagFI";
    FlagIcons["FLAG_FJ"] = "flagFJ";
    FlagIcons["FLAG_FK"] = "flagFK";
    FlagIcons["FLAG_FM"] = "flagFM";
    FlagIcons["FLAG_FR"] = "flagFR";
    FlagIcons["FLAG_GA"] = "flagGA";
    FlagIcons["FLAG_GB"] = "flagGB";
    FlagIcons["FLAG_GD"] = "flagGD";
    FlagIcons["FLAG_GE"] = "flagGE";
    FlagIcons["FLAG_GG"] = "flagGG";
    FlagIcons["FLAG_GH"] = "flagGH";
    FlagIcons["FLAG_GI"] = "flagGI";
    FlagIcons["FLAG_GM"] = "flagGM";
    FlagIcons["FLAG_GN"] = "flagGN";
    FlagIcons["FLAG_GQ"] = "flagGQ";
    FlagIcons["FLAG_GR"] = "flagGR";
    FlagIcons["FLAG_GT"] = "flagGT";
    FlagIcons["FLAG_GW"] = "flagGW";
    FlagIcons["FLAG_GY"] = "flagGY";
    FlagIcons["FLAG_HK"] = "flagHK";
    FlagIcons["FLAG_HN"] = "flagHN";
    FlagIcons["FLAG_HR"] = "flagHR";
    FlagIcons["FLAG_HT"] = "flagHT";
    FlagIcons["FLAG_HU"] = "flagHU";
    FlagIcons["FLAG_ID"] = "flagID";
    FlagIcons["FLAG_IE"] = "flagIE";
    FlagIcons["FLAG_IL"] = "flagIL";
    FlagIcons["FLAG_IM"] = "flagIM";
    FlagIcons["FLAG_IN"] = "flagIN";
    FlagIcons["FLAG_IQ"] = "flagIQ";
    FlagIcons["FLAG_IR"] = "flagIR";
    FlagIcons["FLAG_IS"] = "flagIS";
    FlagIcons["FLAG_IT"] = "flagIT";
    FlagIcons["FLAG_JE"] = "flagJE";
    FlagIcons["FLAG_JM"] = "flagJM";
    FlagIcons["FLAG_JO"] = "flagJO";
    FlagIcons["FLAG_JP"] = "flagJP";
    FlagIcons["FLAG_KE"] = "flagKE";
    FlagIcons["FLAG_KG"] = "flagKG";
    FlagIcons["FLAG_KH"] = "flagKH";
    FlagIcons["FLAG_KM"] = "flagKM";
    FlagIcons["FLAG_KN"] = "flagKN";
    FlagIcons["FLAG_KP"] = "flagKP";
    FlagIcons["FLAG_KR"] = "flagKR";
    FlagIcons["FLAG_KW"] = "flagKW";
    FlagIcons["FLAG_KY"] = "flagKY";
    FlagIcons["FLAG_KZ"] = "flagKZ";
    FlagIcons["FLAG_LA"] = "flagLA";
    FlagIcons["FLAG_LB"] = "flagLB";
    FlagIcons["FLAG_LC"] = "flagLC";
    FlagIcons["FLAG_LI"] = "flagLI";
    FlagIcons["FLAG_LK"] = "flagLK";
    FlagIcons["FLAG_LR"] = "flagLR";
    FlagIcons["FLAG_LS"] = "flagLS";
    FlagIcons["FLAG_LT"] = "flagLT";
    FlagIcons["FLAG_LU"] = "flagLU";
    FlagIcons["FLAG_LV"] = "flagLV";
    FlagIcons["FLAG_LY"] = "flagLY";
    FlagIcons["FLAG_MA"] = "flagMA";
    FlagIcons["FLAG_MC"] = "flagMC";
    FlagIcons["FLAG_MD"] = "flagMD";
    FlagIcons["FLAG_ME"] = "flagME";
    FlagIcons["FLAG_MG"] = "flagMG";
    FlagIcons["FLAG_MK"] = "flagMK";
    FlagIcons["FLAG_ML"] = "flagML";
    FlagIcons["FLAG_MM"] = "flagMM";
    FlagIcons["FLAG_MN"] = "flagMN";
    FlagIcons["FLAG_MO"] = "flagMO";
    FlagIcons["FLAG_MR"] = "flagMR";
    FlagIcons["FLAG_MS"] = "flagMS";
    FlagIcons["FLAG_MT"] = "flagMT";
    FlagIcons["FLAG_MU"] = "flagMU";
    FlagIcons["FLAG_MV"] = "flagMV";
    FlagIcons["FLAG_MW"] = "flagMW";
    FlagIcons["FLAG_MX"] = "flagMX";
    FlagIcons["FLAG_MY"] = "flagMY";
    FlagIcons["FLAG_MZ"] = "flagMZ";
    FlagIcons["FLAG_NA"] = "flagNA";
    FlagIcons["FLAG_NE"] = "flagNE";
    FlagIcons["FLAG_NG"] = "flagNG";
    FlagIcons["FLAG_NI"] = "flagNI";
    FlagIcons["FLAG_NL"] = "flagNL";
    FlagIcons["FLAG_NO"] = "flagNO";
    FlagIcons["FLAG_NP"] = "flagNP";
    FlagIcons["FLAG_NZ"] = "flagNZ";
    FlagIcons["FLAG_OM"] = "flagOM";
    FlagIcons["FLAG_PA"] = "flagPA";
    FlagIcons["FLAG_PE"] = "flagPE";
    FlagIcons["FLAG_PF"] = "flagPF";
    FlagIcons["FLAG_PG"] = "flagPG";
    FlagIcons["FLAG_PH"] = "flagPH";
    FlagIcons["FLAG_PK"] = "flagPK";
    FlagIcons["FLAG_PL"] = "flagPL";
    FlagIcons["FLAG_PR"] = "flagPR";
    FlagIcons["FLAG_PT"] = "flagPT";
    FlagIcons["FLAG_PW"] = "flagPW";
    FlagIcons["FLAG_PY"] = "flagPY";
    FlagIcons["FLAG_QA"] = "flagQA";
    FlagIcons["FLAG_RO"] = "flagRO";
    FlagIcons["FLAG_RS"] = "flagRS";
    FlagIcons["FLAG_RU"] = "flagRU";
    FlagIcons["FLAG_RW"] = "flagRW";
    FlagIcons["FLAG_SA"] = "flagSA";
    FlagIcons["FLAG_SB"] = "flagSB";
    FlagIcons["FLAG_SC"] = "flagSC";
    FlagIcons["FLAG_SD"] = "flagSD";
    FlagIcons["FLAG_SE"] = "flagSE";
    FlagIcons["FLAG_SG"] = "flagSG";
    FlagIcons["FLAG_SH"] = "flagSH";
    FlagIcons["FLAG_SI"] = "flagSI";
    FlagIcons["FLAG_SK"] = "flagSK";
    FlagIcons["FLAG_SL"] = "flagSL";
    FlagIcons["FLAG_SM"] = "flagSM";
    FlagIcons["FLAG_SN"] = "flagSN";
    FlagIcons["FLAG_SO"] = "flagSO";
    FlagIcons["FLAG_SR"] = "flagSR";
    FlagIcons["FLAG_ST"] = "flagST";
    FlagIcons["FLAG_SV"] = "flagSV";
    FlagIcons["FLAG_SY"] = "flagSY";
    FlagIcons["FLAG_SZ"] = "flagSZ";
    FlagIcons["FLAG_TC"] = "flagTC";
    FlagIcons["FLAG_TD"] = "flagTD";
    FlagIcons["FLAG_TG"] = "flagTG";
    FlagIcons["FLAG_TH"] = "flagTH";
    FlagIcons["FLAG_TJ"] = "flagTJ";
    FlagIcons["FLAG_TL"] = "flagTL";
    FlagIcons["FLAG_TM"] = "flagTM";
    FlagIcons["FLAG_TN"] = "flagTN";
    FlagIcons["FLAG_TO"] = "flagTO";
    FlagIcons["FLAG_TR"] = "flagTR";
    FlagIcons["FLAG_TT"] = "flagTT";
    FlagIcons["FLAG_TW"] = "flagTW";
    FlagIcons["FLAG_TZ"] = "flagTZ";
    FlagIcons["FLAG_UA"] = "flagUA";
    FlagIcons["FLAG_UG"] = "flagUG";
    FlagIcons["FLAG_US"] = "flagUS";
    FlagIcons["FLAG_UY"] = "flagUY";
    FlagIcons["FLAG_UZ"] = "flagUZ";
    FlagIcons["FLAG_VC"] = "flagVC";
    FlagIcons["FLAG_VE"] = "flagVE";
    FlagIcons["FLAG_VG"] = "flagVG";
    FlagIcons["FLAG_VN"] = "flagVN";
    FlagIcons["FLAG_VU"] = "flagVU";
    FlagIcons["FLAG_WS"] = "flagWS";
    FlagIcons["FLAG_WW"] = "flagWW";
    FlagIcons["FLAG_YE"] = "flagYE";
    FlagIcons["FLAG_ZA"] = "flagZA";
    FlagIcons["FLAG_ZM"] = "flagZM";
    FlagIcons["FLAG_ZW"] = "flagZW";
})(FlagIcons || (FlagIcons = {}));
//# sourceMappingURL=icons.types.js.map